import { Depot, Instance, Objekt, Promize, Table } from '@siposdani87/sui-js';
import { initTable } from '@utils/collectionSetup';
import { app } from '../app';
import { ReportService } from '@services/reportService';
import { TrophyService } from '@services/trophyService';
import { DashboardController } from './dashboardController';

export class ReportsBuildingsWhatTheyShootController extends DashboardController {
    static readonly inject = [
        'instances',
        'reportService',
        'trophyService',
    ] as const;

    localDepot: Depot;
    table!: Table;

    constructor(
        instances: Instance,
        private reportService: ReportService,
        private trophyService: TrophyService,
    ) {
        super(instances);

        this.localDepot = instances.localDepot;
    }

    protected override _initLayout(): void {
        this._initToolbarButtons();

        this._drawContent();
    }

    protected override _drawContent(): Promize | boolean {
        this._initTrophyTable();
        return true;
    }

    private _initToolbarButtons(): void {
        this.helper.iconButton('.btn-reports-index', this.dom, () => {
            this.state.goBack('reports.index');
        });

        this.helper.fabButton('.btn-reports-filter', this.dom, () => {
            this.reportService.detailsDialog('buildings');
        });
    }

    private _initTrophyTable(): void {
        this.table = initTable(
            this.table,
            this.dom,
            '.trophies-table',
            this.trophyService,
            {
                entityKey: 'trophies',
                fetchData: (params) => {
                    const buildingsReport = new Objekt(
                        this.localDepot.get(
                            this.reportService.getStorageKeyReport('buildings'),
                        ),
                    );
                    return this.reportService.getAllByBuildings(
                        buildingsReport,
                        params,
                    );
                },
            },
        )!;
    }
}

export const reportsBuildingsWhatTheyShootController = app.controller(
    'reportsBuildingsWhatTheyShootController',
    ReportsBuildingsWhatTheyShootController,
);
